import request from '@/plugins/axios'


//含有params的get
// 获取全部媒体
export function allMedia(params) {
    return request[0]({
        url: '/emp/_internal_/media/listMedia',
        method: 'get',
        params,
    })
}

//含有params的get
// 获取单个媒体的信息
export function getMedia(params) {
    return request[0]({
        url: '/emp/_internal_/media/getMedia',
        method: 'get',
        params,
    })
}

//post
// 修改媒体信息
export function updateMedia(params, data) {
    return request[0]({
        url: '/emp/_internal_/media/updateMedia',
        method: 'post',
        params,
        data
    })
}

//含有params的get
// 获取单个媒体的期次列表
export function listMediaDate(params) {
    return request[0]({
        url: '/emp/_internal_/mediaDate/listMediaDate',
        method: 'get',
        params,
    })
}

//含有params的get
// 获取单个媒体某个期次版面列表
export function listPage(params) {
    return request[0]({
        url: '/emp/_internal_/page/listPage',
        method: 'get',
        params,
    })
}

//含有params的get
// 获取单个版面信息
export function getPage(params) {
    return request[0]({
        url: '/emp/_internal_/page/getPage',
        method: 'get',
        params,
    })
}

//含有params的get
// 查询稿件列表
export function listArticle(params) {
    return request[0]({
        url: '/emp/_internal_/article/listArticle',
        method: 'get',
        params,
    })
}

//含有params的get
// 查询单个稿件基本信息
export function getArticle(params) {
    return request[0]({
        url: '/emp/_internal_/article/getArticle',
        method: 'get',
        params,
    })
}

//post
// 删除稿件信息
export function deleteArticle(params, data) {
    return request[0]({
        url: '/emp/_internal_/article/deleteArticle',
        method: 'post',
        params,
        data
    })
}

//post
// 修改稿件信息
export function updateArticle(params, data) {
    return request[0]({
        url: '/emp/_internal_/article/updateArticle',
        method: 'post',
        params,
        data
    })
}

//post
// 设置稿件内容
export function setContent(params, data) {
    return request[0]({
        url: '/emp/_internal_/article/setContent',
        method: 'post',
        params,
        data
    })
}

//post
// 添加稿件信息
export function addArticle(params, data) {
    return request[0]({
        url: '/emp/_internal_/article/addArticle',
        method: 'post',
        params,
        data
    })
}

//含有params的get
// 查询单个视频基本信息
export function getVideo(params) {
    return request[0]({
        url: '/emp/_internal_/video/getVideo',
        method: 'get',
        params,
    })
}

//含有params的get
// 查询视频列表
export function listVideo(params) {
    return request[0]({
        url: '/emp/_internal_/video/listVideo',
        method: 'get',
        params,
    })
}

//含有params的get
// 查询版面热区列表
export function listPageMap(params) {
    return request[0]({
        url: '/emp/_internal_/pageMap/listPageMap',
        method: 'get',
        params,
    })
}

//post
// 删除版面信息
export function deletePage(params, data) {
    return request[0]({
        url: '/emp/_internal_/page/deletePage',
        method: 'post',
        params,
        data
    })
}


//post
// 修改版面信息
export function updatePage(params, data) {
    return request[0]({
        url: '/emp/_internal_/page/updatePage',
        method: 'post',
        params,
        data
    })
}

//post
// 添加版面
export function addPage(params, data) {
    return request[0]({
        url: '/emp/_internal_/page/addPage',
        method: 'post',
        params,
        data
    })
}

//含有params的get
// 获取单个期次信息
export function getMediadate(params) {
    return request[0]({
        url: '/emp/_internal_/mediaDate/getMediadate',
        method: 'get',
        params,
    })
}

//post
// 添加期次
export function addMediaDate(params, data) {
    return request[0]({
        url: '/emp/_internal_/mediaDate/addMediaDate',
        method: 'post',
        params,
        data
    })
}

//post
// 修改期次
export function updateMediaDate(params, data) {
    return request[0]({
        url: '/emp/_internal_/mediaDate/updateMediaDate',
        method: 'post',
        params,
        data
    })
}

//post
// 删除热区
export function deletePageMap(params, data) {
    return request[0]({
        url: '/emp/_internal_/pageMap/deletePageMap',
        method: 'post',
        params,
        data
    })
}

//post
// 修改热区
export function updatePageMap(params, data) {
    return request[0]({
        url: '/emp/_internal_/pageMap/updatePageMap',
        method: 'post',
        params,
        data
    })
}

//post
// 修改热区
export function addPageMap(params, data) {
    return request[0]({
        url: '/emp/_internal_/pageMap/addPageMap',
        method: 'post',
        params,
        data
    })
}

//post
// 获取阿里云STS信息
export function getAliyunSts(params, data) {
    return request[0]({
        url: '/emp/_internal_/file/getAliyunSts',
        method: 'post',
        params,
        data
    })
}

//post
// 钉钉登录，获取令牌
export function dingTalkLogin(params, data) {
    return request[0]({
        url: '/bmp/sso/internalUserDingTalkLogin',
        method: 'post',
        params,
    })
}

//post
// 账号登录，获取令牌
export function userLogin(params, data) {
    return request[0]({
        url: '/bmp/sso/internalUserLogin',
        method: 'post',
        params,
    })
}

//post
// 修改视频信息
export function updateVideo(params, data) {
    return request[0]({
        url: '/emp/_internal_/video/updateVideo',
        method: 'post',
        params,
        data
    })
}

//get
// 查询当前用户的收藏媒体列表
export function listFavoriteMedia(params) {
    return request[0]({
        url: '/emp/_internal_/user/listFavoriteMedia',
        method: 'get',
        params
    })
}

//post
// 新增媒体收藏
export function addFavoriteMedia(params, data) {
    return request[0]({
        url: '/emp/_internal_/user/addFavoriteMedia',
        method: 'post',
        params,
        data
    })
}

//post
// 删除媒体收藏
export function removeFavoriteMedia(params, data) {
    return request[0]({
        url: '/emp/_internal_/user/removeFavoriteMedia',
        method: 'post',
        params,
        data
    })
}

// get
// 已登录用户获取自身信息
export function getUserIdentity(params) {
    return request[0]({
        url: '/bmp/_internal_/internalUserCenter/getUserIdentity',
        method: 'get',
    })
}

// get
// 查询当前用户信息
export function getMyUserInfo(params) {
    return request[0]({
        url: '/emp/_internal_/user/getMyUserInfo',
        method: 'get',
    })
}

//get
// 查询当前用户的收藏媒体列表
export function listPackage(params) {
    return request[0]({
        url: '/emp/_internal_/package/listPackage',
        method: 'get',
        params
    })
}

//get
// 查询校对媒体列表
export function listProofMedia(params) {
    return request[0]({
        url: '/emp/_internal_/media/listProofMedia',
        method: 'get',
        params
    })
}

export function editorUrl() {
    return window.location.origin
}